import { createAction, props } from '@ngrx/store';
import * as models from '../../domain/models';

export const load = createAction('[Charter.AircraftModel] Load');
export const loadSuccess = createAction(
  '[Charter.AircraftModel] Load Success',
  props<{ entities: Array<models.AircraftModel> }>()
);
export const loadFail = createAction('[Charter.AircraftModel] Load Fail');
